var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tapout-component',{staticClass:"text-container",style:({
      transform: ("translate(" + (_vm.x + _vm.dx) + "px, " + (_vm.y + _vm.dy) + "px)"),
      width: ((_vm.setTextWidth + 10) + "px")
    }),attrs:{"id":"textContainer"},on:{"tapout":_vm.onBlur,"onClick":function($event){return _vm.$emit('onClick')}}},[_c('div',{staticClass:"text-box",class:[
        !_vm.operation ? 'grab' : '',
        _vm.operation === 'move' ? 'grabbing' : '',
        ['edit', 'tool'].includes(_vm.operation) ? 'disabled-border' : '',
        _vm.edit === true ? 'dotted-red-border' : ''
      ],on:{"mousedown":_vm.handlePanStart,"touchstart":_vm.handlePanStart}}),_vm._v(" "),_c('div',{ref:"editable",staticClass:"editable-text",style:({
        color: 'black',
        fontSize: ((this.size) + "px"),
        fontFamily: ((this.fontFamily_) + ", serif"),
        lineHeight: ("" + (this.lineHeight_)),
        textAlign: ("" + (this.textAlign)),
        fontWeight: ("" + (this.fontWeight)),
        background: ("" + _vm.textBackground),
        fontStyle: ("" + (this.fontStyle))
      }),attrs:{"contenteditable":_vm.textEditable,"spellcheck":"false"},on:{"focus":_vm.onFocus,"keydown":_vm.onKeydown,"paste":function($event){$event.preventDefault();return _vm.onPaste($event)}}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b25bf986","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/components/pdf-lib-contents/TextItem.vue
// module id = null
// module chunks = 